
import React, { useEffect } from 'react';
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import { useLanguage } from '@/contexts/LanguageContext';
import { translations } from '@/utils/translations';
import { updateMetaTags, getCanonicalUrl } from '@/utils/seoUtils';
import HeroSection from '@/components/why-future-level/HeroSection';
import ReasonSection from '@/components/why-future-level/ReasonSection';
import DifferenceSection from '@/components/why-future-level/DifferenceSection';
import CTASection from '@/components/why-future-level/CTASection';
import AOS from 'aos';
import 'aos/dist/aos.css';

const WhyFutureLevelPage = () => {
  const { currentLanguage } = useLanguage();
  const t = translations[currentLanguage];
  
  useEffect(() => {
    AOS.init({
      duration: 800,
      easing: 'ease-in-out',
      once: true,
    });
    
    // Update SEO meta tags based on current language
    const metaTitles = {
      de: 'Warum Future Level | KI-Videomarketing Agentur Schweiz',
      en: 'Why Future Level | AI Video Marketing Agency Switzerland',
      fr: 'Pourquoi Future Level | Agence de Vidéo Marketing IA Suisse',
      it: 'Perché Future Level | Agenzia di Video Marketing IA Svizzera'
    };
    
    const metaDescriptions = {
      de: 'Entdecken Sie, warum Future Level Ihre KI-basierte Videomarketing-Agentur ist. Mehrsprachige KI-Videos mit lokalem Know-how für maximalen Erfolg.',
      en: 'Discover why Future Level is your AI-based video marketing agency of choice. Multilingual AI videos with local expertise for maximum success.',
      fr: 'Découvrez pourquoi Future Level est votre agence de marketing vidéo basée sur l\'IA. Vidéos IA multilingues avec expertise locale pour un succès maximal.',
      it: 'Scopri perché Future Level è la tua agenzia di video marketing basata sull\'IA. Video IA multilingue con competenza locale per il massimo successo.'
    };
    
    const metaKeywords = {
      de: 'warum Future Level, KI Videoagentur Schweiz, beste Video Marketing Agentur CH, AI Produktvideo Anbieter, KI Videomarketing Zürich, Videomarketing Agentur Schweiz',
      en: 'why Future Level, AI video agency Switzerland, best video marketing agency CH, AI product video provider, AI video marketing Zurich, video marketing agency Switzerland',
      fr: 'pourquoi Future Level, agence vidéo IA Suisse, meilleure agence marketing vidéo CH, fournisseur vidéo produit IA, marketing vidéo IA Genève, agence marketing vidéo Suisse',
      it: 'perché Future Level, agenzia video IA Svizzera, migliore agenzia marketing video CH, fornitore video prodotto IA, marketing video IA Lugano, agenzia marketing video Svizzera'
    };
    
    updateMetaTags({
      title: metaTitles[currentLanguage],
      description: metaDescriptions[currentLanguage],
      keywords: metaKeywords[currentLanguage],
      canonicalUrl: getCanonicalUrl('why-future-level', currentLanguage),
      language: currentLanguage,
      ogType: "article"
    });
  }, [currentLanguage]);

  return (
    <div className="flex flex-col min-h-screen">
      <Header />
      <main className="flex-grow pt-16">
        <HeroSection />
        <ReasonSection />
        <DifferenceSection />
        <CTASection />
      </main>
      <Footer />
    </div>
  );
};

export default WhyFutureLevelPage;
